import styled from '@emotion/styled';

export const ZoomWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ViewerContainer = styled.div<{
  zoomLevel: number;
  isMobile?: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  transform: scale(${(props) => props.zoomLevel});
  transform-origin: ${(props) =>
    props.zoomLevel <= 1
      ? 'center'
      : props.isMobile
      ? 'left center'
      : 'left top'};
`;
